import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AppComponent } from '../component';
import rp from '@reporting/rp-app-host';

@customElement('rp-app-customlogo')
export class CustomLogo extends AppComponent {

	get accounting() {
		return rp.accountingProvider?.accounting;
	}

	get idLogo() {
		return this.accounting?.id_logo;
	}

	static styles = css`
		.logo {
			container-type: inline-size;
			overflow: hidden;
		}

		.logo img {
			display: none;
			height: 40px;
			font-size: 26px;
			color: var(--og-accent-color);
		}

		@container (width > 100px) {
			.logo img {
				display: block;
			}
		}
	`;

	render = () => this.idLogo ? html`
		<div class="logo">
			<img class="logo-square" src="${rp.options.gatewayUrl}/${rp.accountingProvider.a}/definition/files/${this.idLogo}/download" alt="${this.accounting.company}" />
		</div>
	` : '';

}
